import React, { useState } from "react";
import styled from "@emotion/styled";
import { reduce } from "lodash";

import IconOnlyLink from "~/components/links/IconOnlyLink";

import transition from "~/utilities/transition";
import trackNavigationEvent from "~/utilities/trackNavigationEvent";
import { isBrowser } from "~/utilities/helpers";

import { useCartContext } from "~/context/CartContext";

import useOnWindowResize from "~/hooks/useOnWindowResize";

import { breakpointNumbers } from "~/theme";

const Cart = styled(IconOnlyLink)`
    ${transition({}, "color")};
    color: ${({ theme }) => theme.colors.typography.defaultLightBackground};

    &:hover,
    &:focus {
        color: ${({ theme }) => theme.colors.typography.linksHover};
    }
`;

const Wrapper = styled.div`
    margin-right: 3rem;
    position: relative;

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        margin: 0 -0.75rem 0 2rem;
    }
`;

const Badge = styled.span`
    background-color: ${({ theme }) => theme.palette.teal};
    color: ${({ theme }) => theme.palette.white};
    font-weight: 700;
    font-size: 1.2rem;
    border-radius: 100%;
    padding: 1px 8px;
    position: absolute;
    left: 80%;
    top: -5px;
    z-index: 1;
`;

const ShoppingCart = () => {
    const { cart } = useCartContext();
    const [isDesktop, setIsDesktop] = useState(false);

    const shoppingCartTotal = reduce(
        cart,
        (total, shoppingCart) => {
            return total + shoppingCart.length;
        },
        0,
    );

    const hasItems = shoppingCartTotal > 0;

    useOnWindowResize(() => {
        if (isBrowser) {
            setIsDesktop(
                window.innerWidth > breakpointNumbers.tabletLandscapeMax,
            );
        }
    });

    return (
        <Wrapper>
            <Cart
                icon="fa-cart-shopping"
                iconLibrary="fas"
                url="/view-cart/"
                screenReaderText={`View Cart ${
                    hasItems ? `: ${shoppingCartTotal} item(s)` : ""
                }`}
                onClick={() =>
                    trackNavigationEvent(false, 1, "Shopping Cart", isDesktop)
                }
            />
            {hasItems ? <Badge>{shoppingCartTotal}</Badge> : null}
        </Wrapper>
    );
};

export default ShoppingCart;
